import fetch from "../fetch";
import get from "lodash/get";

export default ({ data, isNew }) => {
  const managerId =
    typeof data.manager_id === "string"
      ? data.manager_id
      : get(data, "manager_id.entity_id", "");

  return fetch({
    path: `/hy/managers${isNew ? "" : `/${managerId}`}`,
    method: isNew ? "POST" : "PUT",
    data: {
      ...data,
      manager_id: managerId,
      funds: get(data, "funds", []).map(
        ({ fund_id: { entity_id } }) => entity_id,
      ),
      vehicle_types: get(data, "vehicle_types", []).map(({ id }) => id),
    },
  });
};
